import React, { useState, useRef, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { createPortal } from "react-dom";
import DashboardIcon from "@mui/icons-material/Dashboard";
import MenuIcon from "@mui/icons-material/Menu";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import TocIcon from '@mui/icons-material/Toc';
import SettingsIcon from '@mui/icons-material/Settings';
import HelpIcon from '@mui/icons-material/Help';
// import ReceiptIcon from '@mui/icons-material/Receipt';
import ImportContactsIcon from '@mui/icons-material/ImportContacts';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import AddCardIcon from '@mui/icons-material/AddCard';
import HandshakeIcon from '@mui/icons-material/Handshake';
import GroupIcon from '@mui/icons-material/Group';
import HistoryEduIcon from '@mui/icons-material/HistoryEdu';
import InventoryIcon from '@mui/icons-material/Inventory';
import FactoryIcon from '@mui/icons-material/Factory';

// Menu List (Keep menu lists as they are)
export const mainMenuItems = [
  { icon: <DashboardIcon />, label: "Dashboard", path: "/dashboard", permission: "hasDashboard" },
  // { icon: <ReceiptIcon />, label: "Transactions", path: "/addBorrower", permission: "hasAccounts" },
  { icon: <AddCardIcon />, label: "Receivables", path: "/receivables", permission: "hasReceivables" },
  { icon: <ReceiptLongIcon />, label: "Payables", path: "/payables", permission: "hasPayables" },
  {
    icon: <ImportContactsIcon />,
    label: "Accounts",
    permission: "-",
    children: [
      { label: "Chart of Accounts", path: "/chartOfAccounts", permission: "hasChartOfAccounts" },
      { label: "Account Types", path: "/accountTypes", permission: "hasAccountTypes" },
      { label: "Bank", path: "/bank", permission: "hasBank" },
      { label: "Checkbook", path: "/checkbook", permission: "hasCheckbook" },
      { label: "Posting Keys", path: "/postingKeys", permission: "hasPostingKeys" },
      { label: "Journals", path: "/journals", permission: "hasJournals" },
    ],
  },
  {
    icon: <HandshakeIcon />,
    label: "Partners",
    permission: "-",
    children: [
      { label: "Customers", path: "/customers", permission: "hasCustomers" },
      { label: "Vendors", path: "/vendors", permission: "hasVendors" },
    ],
  },
  {
    icon: <TocIcon />,
    label: "Maintenance",
    permission: "-",
    children: [
      { label: "Billing Type", path: "/billingType", permission: "hasBillingType" },
      { label: "Business Area", path: "/businessArea", permission: "hasBusinessArea" },
      { label: "Company", path: "/company", permission: "hasCompany" },
      { label: "Conversion", path: "/conversion", permission: "hasConversion" },
      { label: "Credit Term", path: "/creditTerm", permission: "hasCreditTerm" },
      //{ label: "Distribution Channel", path: "/distributionChannel", permission: "hasDashboard" },
      { label: "Document Type", path: "/documentType", permission: "hasDocumentType" },
      //{ label: "Industry", path: "/industry", permission: "hasDashboard" },
      { label: "Payment Method", path: "/paymentMethod", permission: "hasPaymentMethod" },
      //{ label: "Purchasing Group", path: "/purchasingGroup", permission: "hasDashboard" },
      //{ label: "Purchasing Org", path: "/purchasingOrg", permission: "hasDashboard" },
      //{ label: "Sales Org", path: "/salesOrg", permission: "hasDashboard" },
      { label: "Taxation Code", path: "/taxationCode", permission: "hasTaxationCode" },
    ],
  },
  { icon: <InventoryIcon />, label: "Items", path: "/items", permission: "hasItems" },
  { icon: <FactoryIcon />, label: "Production", path: "/production", permission: "hasProduction" },
  { icon: <GroupIcon />, label: "Users", path: "/users", permission: "hasUsers" },
  {
    icon: <HistoryEduIcon />,
    label: "Reports",
    permission: "-",
    children: [
      { label: "Bank Reconciliation", path: "/bankReconciliation", permission: "hasBankReconciliation" },
      { label: "BIR Report", path: "/birReport", permission: "hasBankReconciliation" },
      { label: "Check Voucher", path: "/checkVoucher", permission: "hasCheckVoucher" },
      { label: "Collection Report", path: "/collectionReport", permission: "hasCollectionReport" },
      { label: "Customer Ledger", path: "/customerLedger", permission: "hasCustomerLedger" },
      { label: "Delivery Report", path: "/deliveryReport", permission: "hasDeliveryReport" },
      { label: "Financial Statement", path: "/financialStatement", permission: "hasFinancialStatement" },
      { label: "General Ledger Report", path: "/generalLedgerReport", permission: "hasGeneralLedgerReport" },
      { label: "Journal Voucher", path: "/journalVoucher", permission: "hasJournalVoucher" },
      // { label: "Other Payable Voucher for Services", path: "/otherPayableVoucherForServices", permission: "hasOtherPayableVoucherForServices" },
      { label: "Outgoing Payment Voucher", path: "/outgoingPaymentVoucher", permission: "hasOutgoingPaymentVoucher" },
      { label: "Production Report", path: "/productionReport", permission: "hasProductionReport" },
      { label: "Purchase Order Report", path: "/purchaseOrderReport", permission: "hasPurchaseOrderReport" },
      { label: "Purchase Register", path: "/purchaseRegister", permission: "hasPurchaseRegister" },
      { label: "Sales Order Report", path: "/salesOrderReport", permission: "hasSalesOrderReport" },
      { label: "Sales Register", path: "/salesRegister", permission: "hasSalesRegister" },
      { label: "Statement of Account", path: "/statementOfAccount", permission: "hasStatementOfAccount" },
      { label: "Vendor Ledger", path: "/vendorLedger", permission: "hasVendorLedger" },
      { label: "Working Trial Balance", path: "/workingTrialBalance", permission: "hasWorkingTrialBalance" },
    ],
  },
];

export const otherMenuItems = [
  { icon: <SettingsIcon />, label: "Settings", path: "/settings", permission: "hasSettings" },
  { icon: <HelpIcon />, label: "Get Help", path: "/getHelp", permission: "hasGetHelp" },
];

const SubmenuItem = ({ item, isSubmenuOpen, location, collapsed, handleSubmenuToggle }) => {
  const buttonRef = useRef(null);
  const panelRef = useRef(null);
  const [panelPos, setPanelPos] = useState({ top: 0, left: 0 });

  const handleClick = (e) => {
    if (collapsed && item.children) {
      const rect = e.currentTarget.getBoundingClientRect();
      setPanelPos({ top: rect.top, left: rect.right + 4 });
    }
    handleSubmenuToggle(item.label);
  };

  // Close submenu if clicked outside (only for collapsed flyout)
  useEffect(() => {
    if (!collapsed || !isSubmenuOpen) return;

    const handleOutsideClick = (e) => {
      if (
        buttonRef.current && !buttonRef.current.contains(e.target) &&
        panelRef.current && !panelRef.current.contains(e.target)
      ) {
        handleSubmenuToggle(null);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, [collapsed, isSubmenuOpen, handleSubmenuToggle]);

  if (item.children) {
    return (
      <div className="relative">
        <button
          ref={buttonRef}
          onClick={handleClick}
          className={`flex items-center justify-between w-[calc(100%-1rem)] p-4 mx-2 my-1 rounded-lg transition-all duration-200
            text-gray-600 hover:bg-theme-color2/20 hover:text-theme-color ${collapsed ? "justify-center" : ""}`}
        >
          <div className="flex items-center gap-4">
            <span className="text-2xl text-theme-color">{item.icon}</span>
            {!collapsed && <span>{item.label}</span>}
          </div>
          {!collapsed && (isSubmenuOpen ? <ExpandLessIcon className="text-theme-color" /> : <ExpandMoreIcon className="text-theme-color" />)}
        </button>

        {/* Expanded state inside sidebar */}
        {!collapsed && (
          <ul className={`overflow-hidden transition-all duration-300 ease-in-out ${isSubmenuOpen ? "" : "max-h-0"}`}>
            {item.children.map((subItem, subIdx) => {
              const subActive = location.pathname === subItem.path;
              return (
                <li key={subIdx} className="ml-10 mt-1">
                  <Link
                    to={subItem.path}
                    className={`block p-2 rounded-l-md text-sm transition-colors ${
                      subActive
                        ? "text-theme-color font-semibold bg-theme-color2/20"
                        : "text-gray-600 hover:text-theme-color hover:bg-theme-color2/20"
                    }`}
                  >
                    - {subItem.label}
                  </Link>
                </li>
              );
            })}
          </ul>
        )}

        {/* Collapsed flyout panel */}
        {collapsed && isSubmenuOpen &&
          createPortal(
            <div
              ref={panelRef}
              style={{ top: panelPos.top, left: panelPos.left }}
              className="fixed w-48 bg-white border border-gray-200 shadow-xl rounded-lg py-1 z-50"
            >
              <div className="px-3 py-2 text-sm text-gray-700 font-bold border-b">{item.label}</div>
              <ul>
                {item.children.map((subItem, subIdx) => {
                  const subActive = location.pathname === subItem.path;
                  return (
                    <li key={subIdx}>
                      <Link
                        to={subItem.path}
                        className={`block px-3 py-2 text-sm transition-colors ${
                          subActive
                            ? "text-theme-color font-semibold bg-theme-color/20"
                            : "text-gray-600 hover:text-theme-color hover:bg-theme-color/20"
                        }`}
                      >
                        {subItem.label}
                      </Link>
                    </li>
                  );
                })}
              </ul>
            </div>,
            document.body
          )}
      </div>
    );
  }

  // Non-children item
  const isActive = location.pathname === item.path;
  return (
    <Link
      to={item.path}
      className={`flex items-center gap-4 p-4 mx-2 my-1 rounded-lg transition-all duration-200 ${
        isActive
          ? "bg-theme-color2/20 text-theme-color font-semibold"
          : "text-gray-600 hover:bg-theme-color2/20 hover:text-theme-color"
      } ${collapsed ? "justify-center" : ""}`}
    >
      <span className="text-2xl text-theme-color">{item.icon}</span>
      {!collapsed && <span>{item.label}</span>}
    </Link>
  );
};

// --- Main Sidebar Component ---
export default function Sidebar() {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false); // New state for mobile
  const [openSubmenu, setOpenSubmenu] = useState(null);
  const location = useLocation();

  const handleSubmenuToggle = (label) => {
    setOpenSubmenu(openSubmenu === label ? null : label);
  };

  // Get accountData
  const accountData = JSON.parse(localStorage.getItem("accountData"));
  const permissions = accountData?.accessTemplate || {};

  // Filter menus based on permission (keep as is)
  const filteredMainMenu = mainMenuItems
    .map(item => {
      if (item.children) {
        const filteredChildren = item.children.filter(child => permissions[child.permission]);
        if (filteredChildren.length === 0) return null;
        return { ...item, children: filteredChildren };
      } else {
        if (!permissions[item.permission]) return null;
        return item;
      }
    })
    .filter(Boolean);

  const filteredOtherMenu = otherMenuItems.filter(item => permissions[item.permission]);

  const mobileOpenHandleClick = () => {
    setMobileOpen(!mobileOpen)
    setCollapsed(false);
  }

  return (
    // Wrapper for mobile toggle and absolute positioning
    <div className="relative">
      
      {/* 1. Mobile Menu Button (assuming it lives outside the sidebar for smaller screens) */}
      <button 
        onClick={() => mobileOpenHandleClick()} 
        className="fixed top-4 left-4 z-50 p-2 rounded-md bg-white shadow-lg lg:hidden" // Only visible on small screens
      >
        <MenuIcon className="text-theme-color" />
      </button>

      {/* 2. Sidebar Backdrop for Mobile */}
      {mobileOpen && (
        <div 
          className="fixed inset-0 bg-black/50 z-40 lg:hidden" 
          onClick={() => setMobileOpen(false)}
        ></div>
      )}

      {/* 3. The Actual Sidebar */}
      <div 
        className={`fixed top-0 left-0 overflow-x-hidden overflow-y-auto h-screen text-white transition-all duration-300 shadow-lg bg-gray-100 z-50 
        ${collapsed ? "w-20" : "w-64"} 
        ${mobileOpen ? "translate-x-0" : "-translate-x-full"} lg:translate-x-0 lg:static`}
      >
        {/* Header */}
        <div className="p-4 sticky top-0 bg-gray-100 z-10">
          <div className="flex items-end justify-between py-2 border-b border-theme-color">
            {!collapsed && (
              <div className="flex items-center justify-center w-full">
                <img src="/main_logo2.png" alt="Avatar" className="w-36 flex" />
                {/* <span className="text-xl font-bold text-theme-color tracking-wide">LoanManSys</span> */}
              </div>
            )}
            { !mobileOpen ? 
              <button onClick={() => setCollapsed(!collapsed)} className="p-2 rounded-md hover:bg-theme-color/20 transition-colors">
                <MenuIcon className="text-theme-color" />
              </button>
              :
              <button onClick={() => setMobileOpen(false)} className="p-2 rounded-md hover:bg-theme-color/20 transition-colors">
                <MenuIcon className="text-theme-color" />
              </button>
            }
          </div>
        </div>

        {/* Main Menu */}
        <ul className="mt-1">
          {filteredMainMenu.map((item, idx) => (
            <li key={idx}>
              <SubmenuItem 
                item={item}
                isSubmenuOpen={openSubmenu === item.label}
                location={location}
                collapsed={collapsed}
                handleSubmenuToggle={handleSubmenuToggle}
              />
            </li>
          ))}
        </ul>

        {/* Other Menu */}
        <ul className="mt-1 mb-4">
          {filteredOtherMenu.map((item, idx) => (
            <li key={idx}>
              <SubmenuItem 
                item={item}
                isSubmenuOpen={openSubmenu === item.label}
                location={location}
                collapsed={collapsed}
                handleSubmenuToggle={handleSubmenuToggle}
              />
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}